const IframeBlock = ({ block }) => {
  const content = block.content;
  let maxWidth = content.width;
  if (maxWidth) {
    const maxWidthNumber = parseInt(maxWidth.replace("px", ""));
    if (maxWidthNumber > 1080 || typeof maxWidthNumber !== "number")
      maxWidth = "1080px";
  } else {
    maxWidth = "1080px";
  }
  return (
    <iframe
      src={content.src}
      height={content.height}
      title={content.title}
      className="iframe-block"
      style={{ maxWidth }}
    ></iframe>
  );
};

export default IframeBlock;